// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"cad98d23","428":"3227d6a8","560":"0e1e4b18","561":"5a16c141","666":"d361f3cc"}[chunkId] + ".chunk.js";
};